import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const productTypeModule = {
  namespaced: true,
  state: {
    productTypes: null,
    productType: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default productTypeModule;
